import Card from 'components/Card/Card.jsx';
import React, { Component } from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import Form from 'react-jsonschema-form';
import { connect } from 'react-redux';
//Redux
import { bindActionCreators } from 'redux';
import widgets from '../../lib/widgets';
import * as FallingQuotesActions from './redux/FallingQuotesActions';

const schema = {
  $id: 'http://example.com/example.json',
  type: 'object',
  definitions: {},
  $schema: 'http://json-schema.org/draft-07/schema#',
  required: ['email'],
  properties: {
    clientId: {
      title: 'Cliente',
      $id: '/properties/clientId',
      type: 'string',
      default: '',
      api: process.env.REACT_APP_URL_API + '/api/clients',
      options: {
        value: 'id',
        label: 'nombre'
      },
      examples: ['5aea75ab681238e7e6d70150']
    },
    email: {
      $id: '/properties/email',
      type: 'string',
      default: '',
      examples: ['direccion@gasoantonio.com']
    },
    password: {
      $id: '/properties/password',
      type: 'string',
      default: '',
      examples: ['sistema']
    },
    tipo: {
      $id: '/properties/tipo',
      type: 'string',
      default: '',
      examples: ['estacion'],
      enum: ['usuario', 'estacion'],
      enumNames: ['Usuario', 'Estacion']
    }
  }
};

const uiSchema = {
  clientId: {
    'ui:widget': 'SelectRemoteWidget'
  },
  email: {
    'ui:widget': 'email'
  },
  password: {
    'ui:widget': 'password'
  }
};

const log = type => console.log.bind(console, type);

class FallingQuotesForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      openConfirm: false,
      openSuccess: false
    };

    console.log('Props', props.match.params);
  }

  componentWillMount() {
    if (this.state.id !== 'create') this.props.findById(this.state.id);
  }

  onSubmit = ({ formData }) => {
    let _this = this;
    console.log('Data submitted: ', formData);
    if (
      formData.password === '' ||
      formData.password === undefined ||
      formData.password === null
    )
      delete formData.password;

    if (this.state.id !== 'create') {
      this.props.update(formData.id, formData).then(function() {
        _this.props.history.push('/admin/reports/falling-quotes');
      });
    } else {
      this.props.create(formData).then(function() {
        _this.props.history.push('/admin/reports/falling-quotes');
      });
    }
  };

  onDelete(confirm = false) {
    let _this = this;
    if (confirm) {
      this.props.remove(this.state.id).then(function() {
        _this.props.history.push('/admin/reports/falling-quotes');
      });
    } else {
      this.setState({ openConfirm: true });
    }
  }

  onBlur = (id, value) => {
    console.log('Data submitted: ', this.state.formData);
  };

  render() {
    let { history, FallingQuotes } = this.props;
    let { id, openConfirm, openSuccess } = this.state;
    return (
      <div className="main-content">
        {openConfirm && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Estás Seguro?"
            onConfirm={() => this.onDelete(true)}
            onCancel={() => this.setState({ openConfirm: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, borrar!"
            cancelBtnText="Cancelar"
            showCancel
          >
            No podrás desaser está opción!
          </SweetAlert>
        )}

        {openSuccess && (
          <SweetAlert
            success
            style={{ display: 'block', marginTop: '-100px' }}
            title="Listo!"
            confirmBtnBsStyle="info"
            onConfirm={() => this.setState({ openSuccess: false })}
          >
            Se ha actualizado correctamente!
          </SweetAlert>
        )}

        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={<legend>Editar Usuario</legend>}
                content={
                  <div>
                    <Form
                      schema={schema}
                      widgets={widgets}
                      uiSchema={uiSchema}
                      onSubmit={this.onSubmit}
                      onBlur={this.onBlur}
                      formData={FallingQuotes.formData}
                      onError={log('errors')}
                    >
                      <div>
                        <Button
                          bsStyle="success"
                          type="submit"
                          className="btn-fill"
                        >
                          Guardar
                        </Button>{' '}
                        <Button
                          bsStyle="default"
                          onClick={() =>
                            history.push('/admin/reports/falling-quotes')
                          }
                        >
                          Cancelar
                        </Button>
                        <div className="pull-right">
                          {id !== 'create' ? (
                            <Button
                              bsStyle="danger"
                              onClick={() => this.onDelete(false)}
                            >
                              Borrar
                            </Button>
                          ) : null}
                        </div>
                      </div>
                    </Form>

                    <div className="clearfix" />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    FallingQuotes: state.FallingQuotes
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(FallingQuotesActions, dispatch);
};

const FallingQuotesConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(FallingQuotesForm);

export default FallingQuotesConnect;



// WEBPACK FOOTER //
// ./src/views/FallingQuotes/FallingQuotesForm.jsx